import { useState, useEffect, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { driftAPI } from '../../lib/api';
import { Button } from '../ui/button';
import { GitCompareArrows } from 'lucide-react';

export default function HierarchyDriftBell() {
  const [drifts, setDrifts] = useState([]);
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const navigate = useNavigate();

  const fetchDrifts = useCallback(async () => {
    try { const r = await driftAPI.list(); setDrifts(r.data.drifts || []); } catch { /* not admin or none pending */ }
  }, []);

  useEffect(() => { fetchDrifts(); const t = setInterval(fetchDrifts, 60000); return () => clearInterval(t); }, [fetchDrifts]);

  useEffect(() => {
    const handleClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  if (drifts.length === 0 && !open) return null;

  return (
    <div className="relative" ref={ref}>
      <Button variant="ghost" size="icon" className="relative" onClick={() => setOpen(!open)} data-testid="drift-bell-btn">
        <GitCompareArrows className="h-5 w-5" strokeWidth={1.5} />
        {drifts.length > 0 && (
          <span className="absolute -top-0.5 -right-0.5 h-4 min-w-[16px] px-1 bg-amber-500 text-white text-[10px] font-bold rounded-full flex items-center justify-center" data-testid="drift-bell-badge">
            {drifts.length > 99 ? '99+' : drifts.length}
          </span>
        )}
      </Button>

      {open && (
        <div className="absolute right-0 top-full mt-2 w-96 bg-card border rounded-sm shadow-lg z-50" data-testid="drift-bell-dropdown">
          <div className="px-4 py-3 border-b">
            <h3 className="font-semibold text-sm">Hierarchy Changes in Zoho CRM</h3>
          </div>
          <div className="max-h-80 overflow-y-auto">
            {drifts.length === 0 ? (
              <div className="py-8 text-center text-muted-foreground text-sm">Nothing to review</div>
            ) : drifts.map((d) => (
              <div
                key={d.id}
                className="px-4 py-3 border-b last:border-b-0 hover:bg-muted/50 cursor-pointer transition-colors"
                onClick={() => { setOpen(false); navigate('/users'); }}
                data-testid={`drift-bell-item-${d.id}`}
              >
                <p className="text-sm font-medium truncate">{d.name}</p>
                <p className="text-xs text-muted-foreground mt-0.5">
                  {d.field_label}: {d.old_value} → <span className="font-medium">{d.new_value}</span>
                </p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
